import Header from './header'
import HeaderQuery from './header.query'

export { HeaderQuery }

export default Header
